import * as yup from "yup";
import { declension } from "../../../../utils/helpers";

const REQUIRED_MESSAGE = 'Поле обовʼязкове для заповнення';
const MIN_MESSAGE = (number = 1) => `Мінімум ${number} ${declension(number, 'символ', 'символа', 'символів')}`;

const schema = yup.object().shape({
    serviceName: yup.string().trim().required(REQUIRED_MESSAGE).min(3, MIN_MESSAGE(3)),
    price: yup.string().required(REQUIRED_MESSAGE).min(1, MIN_MESSAGE(1)),
    paidService: yup.string().required(REQUIRED_MESSAGE).min(1, MIN_MESSAGE(1)),
});

export default schema;